import { MiniTooltip, Select, SelectOption, Theme, TrashIcon } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { SHELF_LIFE_BRACKET_OPTIONS } from '../reserve-price-settings/reserve-price-constants';

const useStyles = createUseStyles(
  {
    bracket: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 16,
      border: `1px solid ${Theme.grey30}`,
      borderRadius: 4,
    },
    bracketDetails: {
      display: 'flex',
      flexDirection: 'row',
      gap: 12,
    },
    trash: {
      width: 24,
      height: 24,
      cursor: 'pointer',
      fill: Theme.grey80,
      '&:hover': {
        fill: Theme.red,
      },
      opacity: 1,
    },
    trashDisabled: {
      opacity: 0.3,
      pointerEvents: 'none',
      cursor: 'not-allowed',
    },
  },
  { name: 'ShelfLifeBracket' },
);

const ShelfLifeBracket = ({ bracket, index, onChange, onRemove, renderMadlib, selectOptions, selectClassName, deleteDisabled }) => {
  const classes = useStyles();
  return (
    <div className={classes.bracket}>
      <div className={classes.bracketDetails}>
        <Select
          containerClassName={selectClassName}
          selectedItem={bracket.selectedBracketRange || SHELF_LIFE_BRACKET_OPTIONS.ALL_INVENTORY}
          onChange={(selected) => onChange(selected, index)}
          autoWidth
        >
          {selectOptions.map((opt) => (
            <SelectOption key={opt.value} value={opt.value}>
              {opt.text}
            </SelectOption>
          ))}
        </Select>
        {renderMadlib && renderMadlib(bracket, index)}
      </div>
      <MiniTooltip text="Delete bracket" position="bottom">
        <div
          onClick={deleteDisabled ? undefined : () => onRemove(index)}
          className={deleteDisabled ? `${classes.trash} ${classes.trashDisabled}` : classes.trash}
          data-testid={`bracket-${index}-trash`}
        >
          <TrashIcon />
        </div>
      </MiniTooltip>
    </div>
  );
};

ShelfLifeBracket.propTypes = {
  bracket: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  renderMadlib: PropTypes.func,
  selectOptions: PropTypes.array.isRequired,
  selectClassName: PropTypes.string,
  deleteDisabled: PropTypes.bool,
};

export default ShelfLifeBracket;
